import { render } from "./reviewer.vue?vue&type=template&id=44897ecb&ts=true"
import script from "./reviewer.vue?vue&type=script&lang=ts"
export * from "./reviewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__